import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApi, putApi } from 'redux/apis';

export const updateEmployeeExcludedFlag = createAsyncThunk(
	'company/updateEmployeeExcludedFlag',
	async (
		{ companyId, value }: { companyId: string; value: boolean },
		thunkAPI
	) => {
		try {
			const response = await putApi(
				`/companies/${companyId}/is-employee-excluded`,
				{
					isEmployeeExcludedInJournal: value,
				}
			);
			return response.data.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);

export const updateJournalSummarizedViewFlag = createAsyncThunk(
	'company/updateJournalSummarizedViewFlag',
	async (
		{ companyId, value }: { companyId: string; value: boolean },
		thunkAPI
	) => {
		try {
			const response = await putApi(
				`/companies/is-summarized-view`,
				{
					isSummarizedJournalView: value,
					companyId: companyId,
				}
			);
			return response.data.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);

export const fetchCompanyById = createAsyncThunk(
	'company/fetchCompanyById',
	async (companyId: string, thunkAPI) => {
		try {
			const response = await getApi(`/companies/${companyId}`);
			console.log('full ress', response);
			return response.data.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);

export const updateTimeHoursDecimalFlag = createAsyncThunk(
	'company/updateTimeHoursDecimalFlag',
	async (
		{ companyId, isTimeHoursDecimal }: { companyId: string; isTimeHoursDecimal: boolean },
		thunkAPI
	) => {
		try {
			const response = await putApi(
				`/companies/is-time-hours-decimal`,
				{
					companyId: companyId,
					isTimeHoursDecimal: isTimeHoursDecimal,
				}
			);
			return response.data.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);

// Spec §6 audit suffix: appended to PrivateNote on AI-posted journals only.
// jeAuditSuffix null → backend default " | Posted by CostAllocation Pro AI".
export const updateJeAuditSuffixSetting = createAsyncThunk(
	'company/updateJeAuditSuffixSetting',
	async (
		{
			companyId,
			jeAuditSuffixEnabled,
			jeAuditSuffix,
		}: { companyId: string; jeAuditSuffixEnabled: boolean; jeAuditSuffix: string | null },
		thunkAPI
	) => {
		try {
			const response = await putApi(`/companies/je-audit-suffix`, {
				companyId,
				jeAuditSuffixEnabled,
				jeAuditSuffix,
			});
			return response.data.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);

export const getColumnVisibilityAction = createAsyncThunk(
	'company/getColumnVisibility',
	async (
		{ companyId, signal }: { companyId: string; signal?: AbortSignal },
		thunkAPI
	) => {
		try {
			const response = await getApi('/companies/company/column-visibility', {
				companyId,
			}, signal);
			return response.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);

export const saveColumnVisibilityAction = createAsyncThunk(
	'company/saveColumnVisibility',
	async (
		{ companyId, columnVisibility }: { companyId: string; columnVisibility: string[] },
		thunkAPI
	) => {
		try {
			const response = await putApi('/companies/company/column-visibility', {
				companyId,
				columnVisibility,
			});
			return response.data;
		} catch (error: any) {
			return thunkAPI.rejectWithValue(error?.response?.data);
		}
	}
);
